import { Roles } from "helpers/enum.helpers";
import { popupItem } from "./popup-item";

const popupItems: any = {
  [Roles.SuperAdmin]: popupItem,

};

export default popupItems;
